import { render, staticRenderFns } from "./CorporateTopUp.vue?vue&type=template&id=ba38906e&scoped=true&"
import script from "./CorporateTopUp.vue?vue&type=script&lang=js&"
export * from "./CorporateTopUp.vue?vue&type=script&lang=js&"
import style0 from "./CorporateTopUp.vue?vue&type=style&index=0&id=ba38906e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba38906e",
  null
  
)

export default component.exports